module.exports = "/assets/data/1abd273684573009df3a0269aa8d1d28-WC1N.data.json";